import { useUIStore } from '@/stores/ui.store'

/** Convenience wrapper around UI toast store */
export function useToast() {
  const add = useUIStore((s) => s.addToast)
  return {
    toast: {
      success: (msg: string) => add(msg, 'success'),
      error:   (msg: string) => add(msg, 'error'),
      info:    (msg: string) => add(msg, 'info'),
      warning: (msg: string) => add(msg, 'warning'),
    },
  }
}
